// frontend/src/components/account/PasswordPanel.jsx
import { Form, Input, Button } from "antd";
import { LockOutlined } from "@ant-design/icons";

const PasswordPanel = ({
  passwordForm,
  isUpdatePasswordLoading,
  handlePasswordUpdate,
}) => {
  return (
    <div style={{ padding: "16px 0" }}>
      <Form
        form={passwordForm}
        layout="vertical"
        onFinish={handlePasswordUpdate}
        style={{ maxWidth: "400px" }}
      >
        <Form.Item
          name="currentPassword"
          label="Current Password"
          rules={[{ required: true, message: "Please enter current password" }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter current password"
            style={{ borderRadius: "6px" }}
          />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New Password"
          rules={[
            { required: true, message: "Please enter new password" },
            { min: 8, message: "Password must be at least 8 characters" },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter new password"
            style={{ borderRadius: "6px" }}
          />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirm New Password"
          rules={[{ required: true, message: "Please confirm new password" }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirm new password"
            style={{ borderRadius: "6px" }}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isUpdatePasswordLoading}
            style={{
              borderRadius: "6px",
              backgroundColor: "#6DB33F",
              borderColor: "#6DB33F",
            }}
          >
            Update Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PasswordPanel;